import { useSelector } from 'react-redux';
import { IMenuItem } from 'models/IMenuItem';
import { Section } from 'components/Section';
import { hasElements, isLegacy, NO_ELEMENT, rm } from 'utils';
import { NotifyLink } from 'components/Shared/NotifyLink';
import {
  breadCrumbsSelector,
  componentName as componentNameSelector,
  channel as channelSelector
} from '../../selector';
import styles from './styles.scss';
import { BreadCrumbs as LegacyBreadcrumbs } from '../default/breadcrumbs';

const HOME_POSITION = 1;
const POSITIVE_INDEX = 1 + HOME_POSITION;

export const BreadCrumbs = () => {
  const breadCrumbs = useSelector(breadCrumbsSelector);
  const channel = useSelector(channelSelector);
  const componentName = useSelector(componentNameSelector);

  if (!hasElements(breadCrumbs)) {
    return NO_ELEMENT;
  }

  if (isLegacy({ channel, componentName })) {
    return <LegacyBreadcrumbs />;
  }

  return (
    <Section className={styles.section} contentClassName={styles.breadCrumbsWrapper}>
      <div className={styles.box} />
      <ol className={styles.breadCrumbs} itemScope itemType="https://schema.org/BreadcrumbList">
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <a href="/" itemProp="item" className={styles.link}>
            <span itemProp="name">{rm('breadcrumbs_home')}</span>
          </a>
          <span>/</span>
          <meta itemProp="position" content={`${HOME_POSITION}`} />
        </li>
        {breadCrumbs.map((b, i) => (
          <BreadCrumb
            key={b.url}
            position={i + POSITIVE_INDEX}
            {...b}
            last={i === breadCrumbs.length - 1}
          />
        ))}
      </ol>
    </Section>
  );
};

interface BreadCrumb extends Pick<IMenuItem, 'ticket' | 'title' | 'url'> {
  position: number;
  last: boolean;
}

const BreadCrumb = ({ last, ...props }: BreadCrumb) => {
  const { ticket, title, url, position } = props;

  return (
    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
      <NotifyLink itemProp="item" className={styles.link} url={url} ticket={ticket}>
        <span itemProp="name">{title}</span>
      </NotifyLink>
      {!last && <span>/</span>}
      <meta itemProp="position" content={`${position}`} />
    </li>
  );
};
